import { render, staticRenderFns } from "./NewsConfiguration.vue?vue&type=template&id=50cb90b8&scoped=true"
import script from "./NewsConfiguration.vue?vue&type=script&lang=js"
export * from "./NewsConfiguration.vue?vue&type=script&lang=js"
import style0 from "./NewsConfiguration.vue?vue&type=style&index=0&id=50cb90b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cb90b8",
  null
  
)

export default component.exports